export default __webpack_public_path__ + "static/media/automatskavrata7.dfcae317.png";